export const DevicesStyles = {
  container: {
    height: 500,
    width: 1,
  },
  containerFilters: {
    display: "flex",
  },
  containerFilterButon: {
    marginLeft: "-60px",
  },
};
